import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { IArticleBase } from '@/types'
import { NoContent } from '@/componentsV2/atoms/NoContent'
import { ArticleCardList } from '@components-v2/molecules/ArticleCardList'
import { useRouter } from 'next/router'
import { ContextWithLink } from '@components-v2/atoms/ContextWithLink'
import styles from './index.module.scss'

type Props = {
  articles: IArticleBase[]
  isCompanyMember: boolean
  companySlug?: string
}

export const CompanyProfileArticles: FC<Props> = ({ articles, isCompanyMember, companySlug }) => {
  const { t } = useTranslation(['articles', 'companies-[id]'])

  const router = useRouter()

  return (
    <div className={styles.container}>
      {articles?.length > 0 ? (
        <ArticleCardList articles={articles} />
      ) : (
        <>
          {isCompanyMember ? (
            <ContextWithLink
              href={`/${router.locale}/companies/${companySlug}/account/articles`}
              i18nKey='p:ストーリー作成ページへのリンク'
              upperText='ストーリーはまだ掲載されていません。'
              lowerText='からストーリー投稿してみましょう。'
            />
          ) : (
            <NoContent>{t('companies-[id]:ストーリーがまだ登録されていません。')}</NoContent>
          )}
        </>
      )}
    </div>
  )
}
